<template>
  <div class="k-image-cropper">
    <input
      class="k-image-cropper__image"
      type="file"
      name="image"
      accept="image/jpg,image/jpeg"
      @change="setImage"
      v-if="isEditing"
    />

    <popup v-show="imgSrc" @close="dropState">
      <template #body>
        <vue-cropper
          ref="cropper"
          :aspect-ratio="1"
          :view-mode="1"
          :src="imgSrc"
        />
      </template>
      <template #bottom>
        <button class="k-article__buy-button k-image-cropper__cancel k-image-cropper__button" @click="dropState">Закрыть</button>
        <button class="k-article__buy-button k-image-cropper__button" v-if="imgSrc && isEditing" @click="cropImage">Обрезать</button>
      </template>
    </popup>
  </div>
</template>
<script>
import 'cropperjs/dist/cropper.css';
import VueCropper from 'vue-cropperjs';
import Popup from './ThePopup';
export default {
  data: () => ({
    imgSrc: '',
    cropImg: '',
    fileMeta: undefined
  }),
  props: {
    isEditing: Boolean,
    onSave: Function
  },
  components: {
    Popup,
    VueCropper
  },
  methods: {
    dropState() {
      this.cropImg = '';
      this.imgSrc = '';
      this.fileMeta = undefined;
    },
    dataURItoBlob(dataURI) {
      const byteString = atob(dataURI.split(',')[1]);
      const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
  
      return new Blob([ab], {type: mimeString});
    },
    cropImage() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();

      const file = this.dataURItoBlob(this.cropImg);
      file.name = this.fileMeta.name;

      this.dropState();
      this.onSave(file);
    },
    setImage(e) {
      const file = e.target.files[0];
      this.fileMeta = file;

      if (!file) return;

      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        console.error('Sorry, FileReader API not supported');

        this.dropState();
        this.onSave(file);
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.k-image-cropper {
  &__image {
    position: absolute;
    cursor: pointer;
    width: 100%;
    height: 100%;
    left: 0;
    bottom: 0;
    right: 0;
    top: 0;
    z-index: 1;
    overflow: hidden;
    opacity: 0;
  }

  &__cancel {
    background-color: #616161;
  }

  &__button {
    border: 0;
  }
}
</style>
